<div>
  <div *ngFor="let question of wizardPagesArray">
    <div *ngIf="question.formNumber === activeFormIndex">
      <div class="d-flex flex-column gap-size-20 wizard-body-height">
        <!-- Wizard header -->
        <div *ngIf="question.formNumber !== 0"
          class="progress-bar-wrapper d-flex justify-content-between align-items-center">
          <button (click)="handleNavigation(question.formNumber)">
            <img src="assets/icons/chevron-dark-left.svg" alt="arrow-left" />
          </button>
          <div class="d-flex gap-size-8">
            <div *ngFor="let progress of progressBar" [ngClass]="
                progress + 1 === activeFormIndex
                  ? 'progress-bar-item__active'
                  : 'progress-bar-item'
              "></div>
          </div>
          <p class="wizard-progress-percentage" [@opacityAnimation]>
            {{
            (100 / showedWizardPages.size) * question.formNumber < 100 ? ( (100 / showedWizardPages.size) *
              question.formNumber ).toFixed(0) : 99 }}% </p>
        </div>

        <div class="wizard-header-titles-wrapper" *ngIf="sessionId">
          <p [ngClass]="
              activeFormIndex === 0 ? 'wizard-title' : 'wizard-header-title'
            " [@fadeDown]>
            {{ question.questionTitle }}
          </p>
          <p *ngIf="question.questionDescription && !isAddressManual" [ngClass]="
              activeFormIndex === 0
                ? 'wizard-text'
                : 'wizard-header-description'
            " [@fadeDown]>
            {{ question.questionDescription }}
          </p>
        </div>

        <!-- Wizard body -->
        <div [ngSwitch]="question.formType" class="wizard-body" *ngIf="sessionId">

          <ng-container *ngSwitchCase="'radioWithIcon'">
            <div [ngClass]="{
                'radio-btns-with-icon': true,
                'wizard-body-scrollbar': question.scrollable
              }">
              <div *ngFor="let option of question.questionOptions; let i = index" [@opacityAnimation]>
                <input type="radio" [name]="question.inputName" [id]="option.id"
                  [checked]="option.value === question.selectedOption" (click)="
                    handleOptionChange(                    
                      option.value,
                      question.formPageName
                    )
                  " />
                <label [for]="option.id" class="lbl-radio">
                  <div class="radio-marker">
                    <img src="assets/icons/check-blue.svg" alt="check" />
                  </div>
                  <div class="radio-content">
                    <div class="radio-title">{{ option.title }}</div>
                  </div>
                </label>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'radio'">
            <div class="radio-btns-without-marker">
              <div *ngFor="let option of question.questionOptions" [@opacityAnimation]>
                <input type="radio" [name]="question.inputName" [id]="option.id"
                  [checked]="option.value === question.selectedOption" (click)="
                    handleOptionChange(                   
                      option.value,
                      question.formPageName
                    )
                  " />
                <label [for]="option.id" class="lbl-radio-without-marker">
                  <div class="radio-content">
                    <div class="radio-title">{{ option.title }}</div>
                  </div>
                </label>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'dateInput'">

            <div class="position-relative wizard-input-wrapper">

              <input matInput [placeholder]="datePlaceholder" [(ngModel)]="dateOfBirth"
                (ngModelChange)="onDateChange($event, question.formPageName)" (keyup)="returnCurser($event)"
                class="pr-5 test-input" id="dateOfBirth" maxlength="11" #dateOfBirthInput />

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                class="position-absolute top-50 end-0 translate-middle-y me-2" width="24" height="24">
                <rect x="3" y="12" width="18" height="6" rx="2"></rect>
                <rect x="2" y="18" width="20" height="4" rx="2"></rect>
                <path d="M6 8v4"></path>
                <path d="M12 8v4"></path>
                <path d="M18 8v4"></path>
                <path d="M6 7c0 .5-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"></path>
                <path d="M12 7c0 .5-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"></path>
                <path d="M18 7c0 .5-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"></path>
              </svg>

            </div>

            <app-wizard-form-btn class="wizard-form-btn" [formInfo]="{
                activeFormNumber: activeFormIndex,
                showedWizardPagesCount: showedWizardPages.size,
                btnDisabled: !question.writtenAnswers?.['dateOfBirth'] || !this.isDateValid(question),
                btnFunction: setActiveFormNumber.bind(this, 'DateOfBirthPage'),
                description:
                  'Exploring Loans Generator plans won\'t affect your credit score.'
              }" />
          </ng-container>

          <ng-container *ngSwitchCase="'input'">
            <div *ngFor="let input of question.inputs">
              <app-wizard-form-input [inputSettings]="{
                  isSmall: input.isSmall ?? false,
                  label: input.inputLabel,
                  id: input.inputId,
                  type: 'text',
                  value: question.writtenAnswers?.[input.inputId],
                  formPageName: question.formPageName,  
                  validationType: input.validationType ?? '',      
                  inputFunction: input.validationType === 'incomeValue' ? handleIncomeValueChange.bind(this) 
                  : input.validationType === 'noNumbers' ? inputFunctionForNoNumbers.bind(this) 
                  : input.validationType === 'noLetters' ? inputFunctionForNoLetters.bind(this) 
                  : input.validationType === 'phoneNumber' ? handleFormatPhoneNumber.bind(this) 
                  : input.validationType === 'email' ?  inputFunctionWithoutValidation.bind(this)
                  : input.validationType === 'zipCode' ? handleFormatZipCode.bind(this)  
                  : handleWrittenAnswers.bind(this, question.formPageName, input.validationType),                    
                }" />
            </div>

            <p *ngIf="question.inputDescription" class="wizard-description mt-15" [@fadeUp]>
              {{ question.inputDescription }}
            </p>

            <app-wizard-form-btn class="wizard-form-btn" [formInfo]="{
                activeFormNumber: activeFormIndex,
                showedWizardPagesCount: showedWizardPages.size,
                btnDisabled: isFormDisabled(question),
                btnFunction: setActiveFormNumber.bind(
                  this,
                  question.formPageName
                ),
                description:
                  ''
              }" />
          </ng-container>

          <ng-container *ngSwitchCase="'select'">
            <app-wizard-form-select [selectSettings]="{
                questionTitle: question.questionTitle ?? '',
                inputName: question.inputName ?? '',
                selectedOption: question.selectedOption ?? '',
                questionOptions: question.questionOptions ?? [], 
                formPageName: question.formPageName,                     
                handleOptionChange: handleOptionChange.bind(this)
              }" />

            <p *ngIf="question.inputDescription" class="wizard-description mt-15" [@fadeUp]>
              {{ question.inputDescription }}
            </p>

            <!-- <app-wizard-form-btn 
              class="wizard-form-btn" 
              [formInfo]="{
                activeFormNumber: activeFormIndex,
                showedWizardPagesCount: showedWizardPages.size,
                btnDisabled: isFormDisabled(question),
                btnFunction: setActiveFormNumber.bind(this, question.formPageName),
                description: 'Exploring Loans Generator plans won\'t affect your credit score.'
              }" 
            /> -->
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="activeFormIndex === showedWizardPages.size" class="wizard-result-wrapper">
  <div class="result-loading-wrapper" [@opacityAnimation]>
    <img src="assets/icons/loading.svg" alt="loading" />
  </div>
  <div [@fadeUp]>
    <p class="section-title text-center">You did it!</p>
    <p class="section-title text-center">
      Now we're just crunching the numbers to get you the best possible offers
    </p>
  </div>
</div>